// extracted by mini-css-extract-plugin
module.exports = {"container":"DYBTBanner_container__26lr0","sellerContainer":"DYBTBanner_sellerContainer__3VF-i","sellerIcon":"DYBTBanner_sellerIcon__Wdwzn"};